import React from 'react';
import {useTranslation} from "react-i18next";
import { Col } from 'reactstrap';

export const InsufficientFundsModal = ({jsonString}) => {
    const { t } = useTranslation();

    const json = JSON.parse(jsonString);

    return (
        <Col lg={9} className="mx-auto">
            <table>
                <thead>
                <tr>
                    <td colSpan="2" className="text-center border-0">Det belopp som begärs är högre än vad som finns tillgängligt i kassan.</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-center border-0">Vill du fortsätta ?</td>
                </tr>
                </thead>
                {/* <tbody>
                <tr>
                    <td className="border-0">{t("attest.balanceAccount")}:</td>
                    <td className="border-0 text-end">{json.AccountBalance} kr</td>
                </tr>
                <tr>
                    <td className="border-0">{t("attest.approvedButNotPaidOut")}:</td>
                    <td className="border-0 text-end">-{json.AttestApproved} kr</td></tr>
                    <tr><td className="border-0">{t("attest.thisProceeding")}:</td><td className="border-0 text-end">-{json.Amount} kr</td></tr>
                    <tr><td className="border-0"></td><td className="border-0"></td></tr>
                    <tr><td className="border-0">{t("attest.missingFunds")}:</td><td className="border-0 text-end">-{json.MissingAmount} kr</td></tr>
                </tbody> */}
            </table>
        </Col>
    );
};